export default __webpack_public_path__ + "static/media/2930 knife block A top.9dfa1e41.png";